import orderDataDict from '@otp/utils/orderDataDict.js';
const { READY_FOR_DELIVERY } = orderDataDict.VALUED_STATUS;
const { MEO } = orderDataDict.OTP_SERVICE_TYPE;
export default {
    'searchList': {
        fieldTrim: true,
        'searchTxt': [
            {
                'name': '批量选择',
                'value': 'batchQueryValue',
                'type': 'input',
                'unfold': true,
                'placeholder': '最多可查询100单，以逗号隔开',
                'selectConfig': {
                    'name': '批量选择',
                    'prop': 'batchQueryKey',
                    'value': 'vdOrderNo',
                    'option': [
                        { 'label': '增值单号', 'prop': 'vdOrderNo',placeholder:'最多可查询100单，以逗号隔开' },
                        { 'label': '任务号', 'prop': 'taskNo',placeholder:'最多可查询100单，以逗号隔开' },
                    ],
                },
                'span': 6
            },
            // {
            //     'name': '增值单号',
            //     'value': 'vdOrderNo',
            //     'type': 'input',
            //     'unfold': true,
            //     'span': 3
            // },
            // {
            //     'name': '任务号',
            //     'value': 'taskNo',
            //     'type': 'input',
            //     'unfold': true,
            //     'span': 3
            // },
            {
                'name': '创建时间',
                'value': 'creatTimes',
                'type': 'time',
                'timeNum': 2,
                'unfold': true,
                'span': 6
            },
            {
                'name': '订单状态',
                'value': 'orderStatus',
                'unfold': true,
                'type': 'select',
                'options': [],
                'optionNum': 'VALUED_TASK_STAUS',
                'span': 4
            }
        ],
        'unfoldState': false,
        'advancedBtn': true
    },
    'table': {
        'clickModify': true,
        'selectBtn': true,
        'leftOperation': true,
        'height': 400,
        'leftWidth': 70,
        'columns': [
            {
                'label': '订单号',
                'align': 'center',
                'prop': 'vdOrderNo',
                'width': 170,
                'sort': true,
                type: 'custom'
            },
            {
                'label': '任务单号',
                'prop': 'taskNo',
                'width': 170,
                'sort': true
            },
            // BUG2022010460601 by 李娟
            // {
            //     'label': '订单类型',
            //     'prop': 'orderType',
            //     'width': 110,
            //     'sort': true
            // },
            {
                'label': '订单状态',
                'prop': 'orderStatus',
                'width': 110,
                'optionNum': 'VALUED_TASK_STAUS',
                'options': [],
                'type': 'select',
                'sort': true
            },
            {
                'label': '平台',
                'align': 'center',
                'prop': 'siteName',
                'width': 170,
                'sort': true
            },
            {
                'label': '客户',
                'align': 'center',
                'prop': 'customerName',
                'width': 170,
                'sort': true
            },
            {
                'label': '仓库',
                'align': 'center',
                'prop': 'whName',
                'width': 130,
                'sort': true
            },
            {
                'label': '服务类型',
                'prop': 'serviceName',
                'width': 100,
                'sort': true
            },
            {
                'label': '来源系统',
                'align': 'center',
                'prop': 'sourceSystemName',
                'width': 160,
                'require': true,
                'sort': true
            },
            {
                'label': '关联单号',
                'align': 'center',
                'prop': 'relationOrderNo',
                'width': 160,
                'require': true,
                'sort': true
            },
            {
                'label': '源单号',
                'align': 'center',
                'prop': 'originalOrderNo',
                'width': 160,
                'require': true,
                'sort': true
            },
            {
                'label': '创建时间',
                'align': 'center',
                'prop': 'createTime',
                'width': 160,
                'sort': true
            },
            {
                'label': '创建人',
                'align': 'center',
                'prop': 'createUserCode',
                'width': 110,
                'sort': true
            },
            {
                'label': '修改时间',
                'align': 'center',
                'prop': 'updateTime',
                'width': 160,
                'sort': true
            },
            {
                'label': '修改人',
                'align': 'center',
                'prop': 'updateUserCode',
                'width': 110,
                'sort': true
            }
        ],
        'action': [
            {
                'type': 'text',
                'label': '撤回',
                'size': 'small',
                'event': 'withdraw',
                'ifHas': '02040002',
                show: (row) => {
                    return +row.orderStatus <= READY_FOR_DELIVERY && row.orderType === MEO;
                }
            }
        ]
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next',
        'pageSize': 10,
        'pageSizes': [
            10,
            20,
            30,
            50,
            100
        ]
    },
    'searchTotalTitle': [
        {
            'name': '客户',
            'value': 'customerName',
            'type': 'advance',
            'unfold': true,
            'advanceConfig': [
                // { 'prop': 'ebcuNameCn', 'value': '客户名称' },
                // { 'prop': 'pmCode', 'value': '客户编码' }
                { 'prop': 'pmCodeOrNameCn', 'value': '客户编码或名称' }
            ],
            'advancePlaceholder': "支持模糊查询",
            'tableConfig': [
                { 'prop': 'pmCode', 'value': '客户编码' },
                { 'prop': 'ebcuNameCn', 'value': '客户名称' }
            ],
            'advanceUrl': '/ebCustomer/searchByEbCustomer',
            'cbParams': ['pmCode#customerCode', 'ebcuNameCn#customerName'],
            'advanceCode': 'advanceCode',
            'span': 4
        },
        {
            'name': '仓库',
            'value': 'whName',
            'unfold': true,
            'advanceConfig': [
                { prop: 'codeAndName', value: '仓库编码或名称' }
                // { 'prop': 'cdwhName', 'value': '仓库名称' },
                // { 'prop': 'whCode', 'value': '仓库编码' }
            ],
            'tableConfig': [
                { 'prop': 'whCode', 'value': '仓库编码' },
                { 'prop': 'cdwhName', 'value': '仓库名称' },
                { 'prop': 'cdwhIsStop', 'value': '状态', type: 'select', options: { 0: '启用', 1: '禁用', 2: '废弃' } }
            ],
            'advanceUrl': 'cdWarehouse/search',
            'cbParams': [
                'whCode', 'cdwhName#whName'
            ],
            'type': 'advance',
            'span': 4
        },
        {
            'name': '服务类型',
            'value': 'serviceType',
            'type': 'select',
            'multiple': false,
            'unfold': true,
            'span': 3,
            'optionNum': 'OTP_SERVICE_TYPE',
            'options': []
        },
        {
            name: '来源系统',
            value: 'sourceSystem',
            type: 'select',
            options: [],
            filterable: true,
            optionNum: 'SOURCE_SYSTEM',
            span: 4,
            unfold: true
        },
        {
            name: '关联单号',
            type: 'input',
            value: 'relationOrderNo',
            width: 160,
            filterable: true,
            span: 4,
            unfold: true
        },
        {
            name: '源单号',
            type: 'input',
            value: 'originalOrderNo',
            width: 160,
            filterable: true,
            span: 4,
            unfold: true
        },
        {
            'name': '平台',
            'value': 'batchSiteName',
            'unfold': true,
            "advanceConfig": [
                { "prop": "escoCompanyNoOrNameCn", "value": "服务平台编码或名称" }
            ],
            "advancePlaceholder": "支持模糊查询",
            "tableConfig": [
                { "prop": "siteCode", "value": "服务平台编码" },
                { "prop": "escoCompanyNameCn", "value": "服务平台名称"},
                { "prop": "companyCode", "value": "分公司编码" },
                { "prop": "companyName", "value": "分公司名称" }
            ],
            "advanceUrl": "/esCompany/searchSiteV2?escoCompanyType=P",
            'maxNum': 100,
            'pageSizes': [10, 30, 50, 100],
            'hideTooltip': true,
            'prefix': '/api-mdm/',
            'type': 'advanceMulti',
            'cbParams': ['escoCompanyNo#batchSiteCode', 'escoCompanyNameCn#batchSiteName'],
            'span': 4
        }
    ],
    // 双十一,去掉最近2个月 by曾泓铄
    'pickerConfig': {
        'shortcuts': [
            { 'type': 'd', 'num': 2, 'text': '最近三天', 'translate': 'component.E202007300011' },
            { 'type': 'd', 'num': 6, 'text': '最近一周', 'translate': 'component.E202007300011' },
            { 'type': 'M', 'num': 1, 'text': '最近一个月', 'translate': 'component.E202007300013' }
        ]
    }
};
